// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [require('ui/web/documentCard').name];

module.exports = angular
  .module('bench.app.dms.statements.unprocessed', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.dms.statements.unprocessed', {
      url: '/:date/ledger/unprocessed/:page?:query',
      params: {
        date: {
          value: 'all',
          squash: true,
        },
        page: {
          value: '1',
          squash: true,
        },
      },
      controller($stateParams) {
        this.$stateParams = $stateParams;
        return this;
      },
      controllerAs: 'vm',
      template: `\
<bl-document-card
  month="vm.$stateParams.month"
  date="vm.$stateParams.date"
  client-id="vm.$stateParams.clientId"
  document-type="STATEMENT"
  page="vm.$stateParams.page"
  file-name="vm.$stateParams.query"
  has-file-name-search="true"
  archived="false"
  refetch="true"
  ledger-id="'no'">
</bl-document-card>\
`,
    }),
  );
